import React, { useState, useEffect } from "react";
import "./resetPassword.scss";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { ResetPasswordSubmit } from "../../services/userService";
import { ToastContainer, toast } from "react-toastify";
import Logo from "../../assets/images/logo.svg";
import ShowPass from "../../assets/images/showPass.svg";
import HidePass from "../../assets/images/hidePass.svg";
import SubmitButton from "../submitButton/submitButton";

function LoginComponent() {
  let navigate = useNavigate();
  const [showPassword, setShowpassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loading, setLoadig] = useState(false);

  const token = new URLSearchParams(window.location.search).get('token');

  useEffect(() => {
    if(!token) {
      navigate("/");
    }
  }, []);

  const handlePasswordVisibility = () => {
    setShowpassword(!showPassword);
  };

  const handlePassword = (e) => {
    setPasswordError(false);
    setPassword(e.target.value);
  };

  const handleEmail = (e) => {
    setEmailError(false);
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setEmailError(true);
    }
    if (password === "") {
      setPasswordError(true);
    }
    if (email !== "" && password !== "") {
      try {
        setLoadig(true);
        let res = await ResetPasswordSubmit(email, password, token);
        setLoadig(false);
        localStorage.setItem("token", res.token);
        localStorage.setItem("fullname", res.fullname);
        localStorage.setItem("role", res.role);
        localStorage.removeItem("searched");
        navigate("/dashboard");
      } catch (err) {
        setLoadig(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  };

  return (
    <div className="login">
      <ToastContainer position="top-center" rtl={true} closeButton={false} style={{fontSize:"0.875rem"}}/>
      <div className="loginContent">
        <div className="content">
          <img src={Logo} alt="logo" />
          <div className="title">تغییر کلمه عبور</div>
          <p>ایمیلی که ثبت نام کردی و کلمه عبور جدیدت رو وارد کن</p>
        </div>
        <form>
          <label
            className={emailError ? "labelError" : ""}
            htmlFor="email"
          >
            ایمیل
          </label>
          <input
            className={emailError ? "inputError" : ""}
            type="text"
            onChange={(e) => handleEmail(e)}
            id="email"
            name="email"
            placeholder="ایمیلت رو اینجا بنویس"
            autoFocus
          />
          <label
            className={passwordError ? "passwordLabelError" : ""}
            htmlFor="password"
          >
            کلمه عبور جدید
          </label>
          <div
            className={passwordError ? "passwordError" : "passwordContainer"}
          >
            <input
              type={showPassword ? "text" : "password"}
              onChange={handlePassword}
              id="password"
              name="password"
              placeholder="کلمه عبور جدیدت رو اینجا بنویس"
            />
            <img
              src={showPassword ? ShowPass : HidePass}
              onClick={handlePasswordVisibility}
              alt="icon"
            />
          </div>
          <SubmitButton onClick={handleSubmit} text="ثبت و ورود" loading={loading} />
        </form>
        <div className="options flex justify-center rtl">
            <div  onClick={() => {
              navigate("/");
            }}>
              بازگشت
            </div>
          </div>
      </div>
    </div>
  );
}
export default LoginComponent;
